import React from 'react'
import { Route, Switch, BrowserRouter } from 'react-router-dom'
import QuizContent from 'pages/QuizContent'
import PrivateRoute from './PrivateRoute'

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <PrivateRoute path="/quiz/signed/url/questions" component={QuizContent} title="Quiz" />
      <Route path="*" component={() => <h1>Esta página não existe!</h1>} />
    </Switch>
  </BrowserRouter>
)

export default Routes
